import { call, fork, select } from 'redux-saga/effects';
import { doFetchModel } from 'features/page-model/ducks/get-model';
import { doFetchProductData } from 'features/product-info/ducks/product-main-info';
import { doFetchProductMedia } from 'features/product-info/ducks/product-media';
import { runReviewsPageRefetch } from 'features/reviews';
import { doFetchMeasurementSettings } from 'features/basket/ducks/measurement-settings';
import { runFetchRelatedProducts } from 'features/related-products';
import { doFetchRelatedServices } from 'features/related-services';
import { doFetchLinkedPages } from 'features/linked-pages/ducks/linked-pages';
import { getIsSetPath } from 'common/selectors';
import { runLoyaltyServices } from '../../features/product-loyalty-rewards/sagas';

export function* fetchModelWithLinkedPages() {
  yield call(doFetchModel);
  yield call(doFetchLinkedPages);
}

export function* fetchState() {
  const isSetPath = (yield select(getIsSetPath)) as ReturnType<typeof getIsSetPath>;

  yield fork(fetchModelWithLinkedPages);
  yield fork(doFetchProductData);
  yield fork(doFetchProductMedia);
  yield fork(runFetchRelatedProducts);
  yield fork(doFetchRelatedServices);
  yield fork(runLoyaltyServices);

  if (!isSetPath) {
    yield fork(doFetchMeasurementSettings);
    yield fork(runReviewsPageRefetch);
  }
}
